// Bootstrap
// import 'bootstrap';

// We need this to have bootstrap available for other plugins
window.bootstrap = require("bootstrap");

window.Cookies = require("js-cookie");

// Bootscore old parent theme js
import "../js/modules/global/bootscore";

// SCSS
import "../scss/main/main.scss";

// jQuery events
import "./modules/jQueryEvents";

// Bootstrap initialisations & edits
import "./modules/bootstrap-helpers";

// Plugin edits
import "./modules/plugins";

// Header
import "./modules/global/header";

// Productpages
import "./modules/global/productpages";
import "./modules/reviews";

// AB Test
import "./modules/ab-tests";

// Thankyou survey
import "./modules/thankyou-survey";

// Iframes
import "./modules/global/iframes";

// Image pretty load
import "./modules/images";

// Cookie notice
import "./modules/helpers/cookieNotice";

import "./modules/hotjar";

// Resize the promotion button through JS
import "./modules/helpers/resizePromotionButton";

// Advent snow
// import "./modules/advent-snow";

// JQuery Template
jQuery(document).ready(function ($) {
	// Do stuff here
}); // jQuery End
